module.exports = __webpack_public_path__ + "media/pdf_missing/motocykl@3x-5a9169ed.svg";